import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xxs};
    padding-bottom: ${theme.v3.spacing.xxl};
    width: 100%;
  `}
`;

export const Row = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.v3.spacing.xxs};
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const WhiteCard = styled.div`
  ${({ theme, $loading, $centerContent }) => css`
    background: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.none};
    margin-top: ${theme.v3.spacing.nano};
    overflow: hidden;
    padding: ${theme.v3.spacing.xxs};
    position: relative;
    width: 100%;
    
    ${$centerContent && css`
      align-items: center;
      display: flex;
      justify-content: center;
      padding: ${theme.v3.spacing.xxxl} !important;
    `}
      
    @media (min-width: ${theme.v3.breakpoints.sm}){
      border-radius: ${theme.v3.border.radius.round};
      padding: ${theme.v3.spacing.sm} ${theme.v3.spacing.xs};
    }

    ${$loading && css`
      display: flex;
      flex-direction: column;
      gap: ${theme.v3.spacing.xxxs};
    `}
  `}
`;

export const WhiteCardHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.v3.spacing.xxxs};

    @media (min-width: ${theme.v3.breakpoints.sm}){
      margin-bottom: ${theme.v3.spacing.xxs};
    }
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[30]};
    line-height: ${theme.v3.font.lineHeight.comfortable};

    @media (min-width: ${theme.v3.breakpoints.sm}){
      font-size: ${theme.v3.font.sizes['2xlarge']};
    }
  `}
`;

export const Subtitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin-top: 16px;

    @media (min-width: ${theme.v3.breakpoints.sm}){
      font-size: ${theme.v3.font.sizes.medium};
    }
  `}
`;

export const WhiteCardContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xxs};

    @media (min-width: ${theme.v3.breakpoints.md}) {
      gap: 16px;
    }
  `}
`;

export const InnerCard = styled.div`
  ${({ theme }) => css`
    border-color: ${theme.v3.colors.neutral[98]};
    border-radius: ${theme.v3.border.radius.round};
    border-style: solid;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0px;
    flex-wrap: wrap;
    border-width: 0px;
    gap: ${theme.v3.spacing.xxxs};
    
    @media (min-width: ${theme.v3.breakpoints.sm}){
      padding: ${theme.v3.spacing.md} ${theme.v3.spacing.xl};
      border-width: ${theme.v3.border.width.thick};
      gap: ${theme.v3.spacing.xl};
    }
  `}
`;

export const InnerCardColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Image = styled.img`
  display: flex;
  width: 100%;
  max-width: 100%;
`;

export const InnerCardColumnTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[30]};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    text-align: center;
  
    @media (min-width: ${theme.v3.breakpoints.sm}){
      font-size: ${theme.v3.font.sizes.huge};
      text-align: left;
    }
  `}
`;

export const InnerCardColumnList = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.nano};
    list-style-type: none;
    margin: ${theme.v3.spacing.xxxs} 0px 0px 0px;
    padding: 0;
    text-align: center;

    svg {
      display: none;
    }
      
    @media (min-width: ${theme.v3.breakpoints.sm}){
      text-align: left;
      gap: ${theme.v3.spacing.xxxs};
      margin: ${theme.v3.spacing.xxs} 0px 0px 0px;
      
      svg {
        display: flex;
      }
    }
  `}
`;

export const InnerCardColumnListItem = styled.li`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v3.colors.neutral[40]};
    display: flex;
    font-size: ${theme.v3.font.sizes.xxs};
    font-weight: ${theme.v3.font.weights.regular};
    gap: ${theme.v3.spacing.xxxs};
    line-height: ${theme.v3.font.lineHeight.comfortable};

    @media (min-width: ${theme.v3.breakpoints.sm}){
      font-size: ${theme.v3.font.sizes['1xmedium']};
    }
  `}
`;

export const InnerCardButtonWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.v3.spacing.xs};

    button {
      width: 100%;
    }

    @media (min-width: ${theme.v3.breakpoints.sm}){
      button {
        width: fit-content;
      }    
    }
  `}
`;

export const ItemsRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.v3.spacing.xxxs};
    margin-top: ${theme.v3.spacing.xxs};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const FreeDomainCard = styled.div`
  ${({ theme }) => css`
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    background: ${theme.v3.colors.brand.snappyBlue[98]};
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
    padding: ${theme.v3.spacing.sm} ${theme.v3.spacing.xs};

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 100%;
      background-image: radial-gradient(${theme.v3.colors.brand.snappyBlue[80]} 1.5px, transparent 1.5px);
      background-size: 20px 20px;
      opacity: 0.5;
      pointer-events: none;
    }
  `}
`;

export const FreeDomainTitle = styled.p`
  ${({ theme }) => css`
    font-size: 24px;
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.brand.snappyBlue[15]};
    line-height: 130%;
    margin: 0;
    position: relative;
    z-index: 1;

    strong {
      font-weight: ${theme.v3.font.weights.bold};
    }
  `}
`;

export const FreeDomainDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: 150%;
    margin: ${theme.v3.spacing.nano} 0 0 0;
    position: relative;
    z-index: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

export const FreeDomainSearchRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.v3.spacing.xxxs};
    margin-top: ${theme.v3.spacing.xxs};
    align-items: center;
    max-width: 780px;
    width: 100%;
    position: relative;
    z-index: 1;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      align-items: stretch;
    }
  `}
`;

export const FreeDomainInputWrapper = styled.div`
  width: 100%;
`;

export const FreeDomainSearchButtonWrapper = styled.div`
  ${({ theme }) => css`
    flex-shrink: 0;

    button {
      background: ${theme.v3.colors.brand.snappyBlue[50]};
      border-radius: 999px;
      color: ${theme.v3.colors.neutral[100]};
      font-size: ${theme.v3.font.sizes.medium};
      font-weight: ${theme.v3.font.weights.medium};
      line-height: ${theme.v3.font.lineHeight.comfortable};
      min-height: 48px;
      min-width: 153px;
      padding: 12px ${theme.v3.spacing.xxxs};
      white-space: nowrap;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      width: 100%;

      button {
        width: 100%;
      }
    }
  `}
`;

export const FreeDomainLinksRow = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: 150%;
    margin: ${theme.v3.spacing.xxxs} 0 0 0;
    position: relative;
    z-index: 1;
  `}
`;

export const FreeDomainLink = styled.a`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[40]};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: 150%;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `}
`;

export const SkeletonRow = styled.div`
  display: flex;
  width: 100%;
`;

export const SkeletonInline = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 16px;
    
    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-wrap: wrap;
    }
  `}
`;

export const WrapperCardsProducts = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: 16px;
    width: 100%;
    
    @media (min-width: ${theme.v3.breakpoints.md}) {
      gap: 24px;
      grid-template-columns: repeat(3, 1fr);
    }
  `}
`;
